import axios from 'axios';
import { getUrl } from '../service-utils';
import authHeader from '../auth-header';
import {
  IBucketList,
  IBucketListItem,
  AddBucketListItemRequest,
  BucketListDiscoveryResult
} from '../../Models/bucket-list/bucket-list.model';

class BucketListService {
  private API_URL: string;

  constructor() {
    this.API_URL = getUrl();
  }

  public async getBucketList(): Promise<IBucketList> {
    try {
      const response = await axios.get(`${this.API_URL}bucket-list`, {
        headers: authHeader()
      });
      return response.data.data.bucketList as IBucketList;
    } catch (error: any) {
      console.error(
        'Error fetching bucket list:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }

  public async addItem(
    item: AddBucketListItemRequest
  ): Promise<IBucketListItem> {
    try {
      const response = await axios.post(
        `${this.API_URL}bucket-list/items`,
        item,
        { headers: authHeader() }
      );
      return response.data.data.item as IBucketListItem;
    } catch (error: any) {
      console.error(
        'Error adding bucket list item:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }

  public async updateItem(
    itemId: string,
    updates: Partial<AddBucketListItemRequest>
  ): Promise<IBucketListItem> {
    try {
      const response = await axios.patch(
        `${this.API_URL}bucket-list/items/${itemId}`,
        updates,
        { headers: authHeader() }
      );
      return response.data.data.item as IBucketListItem;
    } catch (error: any) {
      console.error(
        'Error updating bucket list item:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }

  public async removeItem(itemId: string): Promise<void> {
    try {
      await axios.delete(`${this.API_URL}bucket-list/items/${itemId}`, {
        headers: authHeader()
      });
    } catch (error: any) {
      console.error(
        'Error removing bucket list item:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }

  public async searchItems(
    query: string,
    region?: string
  ): Promise<IBucketListItem[]> {
    try {
      const params = new URLSearchParams();
      if (query) params.append('q', query);
      if (region) params.append('region', region);
      const response = await axios.get(
        `${this.API_URL}bucket-list/search?${params.toString()}`,
        { headers: authHeader() }
      );
      return response.data.data.items as IBucketListItem[];
    } catch (error: any) {
      console.error(
        'Error searching bucket list:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }

  public async discoverySearch(
    query: string,
    region?: string
  ): Promise<BucketListDiscoveryResult[]> {
    try {
      const params = new URLSearchParams();
      if (query) params.append('q', query);
      if (region) params.append('region', region);
      const response = await axios.get(
        `${this.API_URL}bucket-list/discovery-search?${params.toString()}`,
        { headers: authHeader() }
      );
      return response.data.data.results as BucketListDiscoveryResult[];
    } catch (error: any) {
      console.error(
        'Error performing discovery search:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }

  public async addItemToTrip(itemId: string, tripId: string): Promise<any> {
    try {
      const response = await axios.post(
        `${this.API_URL}bucket-list/items/${itemId}/add-to-trip/${tripId}`,
        {},
        { headers: authHeader() }
      );
      return response.data.data;
    } catch (error: any) {
      console.error(
        'Error adding bucket list item to trip:',
        error?.response?.data || error.message
      );
      throw error?.response?.data || error;
    }
  }
}

const bucketListService = new BucketListService();
export default bucketListService;
